export default {
  mounted () {
    const { skipType, couponSerialNo } = this.$route.query
    if (['CREDIT_APPLY', 'LOAN_APPLY'].includes(skipType)) {
      return this.$router.replace({
        path: '/middle/limit'
      })
    }
    if (skipType === 'COUPON_LIST') {
      // ['USED', 'CREDIT_LOCKED', 'TIMEOUT'].includes(couponStatus) ? '/quan/history' : '/quan/list',
      return this.$router.replace({
        path: '/quan/list'
      })
    }
    if (skipType === 'PROVIDE_DETAIL') {
      return this.$router.replace({
        path: '/quan/detail',
        query: {
          couponRecordId: couponSerialNo
        }
      })
    }
    this.$bus.$emit('ready')
  },

  render () {
    return <div />
  }
}
